import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import fr from "./fr.json";
import de from "./de.json";
import en from "./en.json";
import es from "./es.json";
import vi from "./vi.json";
import it from "./it.json";
import ca from "./ca.json";
import pt from "./pt.json";
import fi from "./fi.json";
import tr from "./tr.json";
import dayjs from "dayjs";
import "dayjs/locale/fr";
import "dayjs/locale/de";
import "dayjs/locale/vi";
import "dayjs/locale/es";
import "dayjs/locale/ca";
import "dayjs/locale/it";
import "dayjs/locale/en";
import "dayjs/locale/pt";
import "dayjs/locale/fi";
import "dayjs/locale/tr";

import relativeTime from "dayjs/plugin/relativeTime";

dayjs.extend(relativeTime);

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: process.env.NODE_ENV !== "production",
    lng: "fr",
    fallbackLng: "fr",
    resources: {
      fr,
      de,
      en,
      es,
      vi,
      it,
      ca,
      pt,
      fi,
      tr,
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });
export default i18n;
